import { usePageableOptions } from 'components/shared/select-multi-choicelist/usePageableOptions';
import { MappedZone } from 'features/wizard/hooks/useZonesWithMappedProviders';
import { ShopifyShippingRate } from 'models/ppoints/ShopifyShippingRate';
import { useCallback, useMemo } from 'react';

const PAGE_SIZE = 20;

const toOption = (rate: ShopifyShippingRate) => ({ value: rate.id, label: rate.name });

export const useZoneRateOptions = (zone: MappedZone, values: number[], enabled: boolean) => {
    const rates = useMemo(
        () => zone.zone.price_based_shipping_rates.concat(zone.zone.weight_based_shipping_rates),
        [zone.zone]
    );

    const ratesSignature = useMemo(() => rates.map((rate) => `${rate.id}:${rate.name}`).join('|'), [rates]);

    const fetchPage = useCallback(
        async (cursor: string | null) => {
            const offset = cursor ? Number(cursor) : 0;
            const page = rates.slice(offset, offset + PAGE_SIZE);
            const nextOffset = offset + page.length;
            return {
                options: page.map(toOption),
                nextCursor: nextOffset < rates.length ? String(nextOffset) : null,
            };
        },
        [rates]
    );

    const fetchByValues = useCallback(
        async (ids: number[]) => {
            return rates.filter((rate) => ids.includes(rate.id)).map(toOption);
        },
        [rates]
    );

    return usePageableOptions<number>({
        key: ['zone-rate-options', zone.id, ratesSignature],
        fetchPage,
        fetchByValues,
        values,
        enabled,
    });
};
